class CartDrawer extends SideDrawer {
  connectedCallback() {
    this.bindEvents();
  }

  bindEvents() {
    this.openDrawerViaEventHandler = this.handleDrawerOpenViaEvent.bind(this);
    this.closeDrawerViaEventHandler = this.close.bind(this, null);
    this.cartRefreshHandler = this.refreshCartContents.bind(this);

    document.addEventListener('dispatch:cart-drawer:open', this.openDrawerViaEventHandler);
    document.addEventListener('dispatch:cart-drawer:close', this.closeDrawerViaEventHandler);
    document.addEventListener('dispatch:cart-drawer:refresh', this.cartRefreshHandler);

    this.addEventListener('on:cart-drawer:before-open', () => {
      theme.manuallyLoadImages(this);
      this.querySelectorAll('cc-cart-cross-sell').forEach((el) => el.init());
    });
    this.addEventListener('on:cart:after-merge', () => {
      theme.manuallyLoadImages(this);
      this.querySelectorAll('cc-cart-cross-sell').forEach((el) => el.init());
    });
  }

  disconnectedCallback() {
    document.removeEventListener('dispatch:cart-drawer:refresh', this.cartRefreshHandler);
    document.removeEventListener('dispatch:cart-drawer:open', this.openDrawerViaEventHandler);
    document.removeEventListener('dispatch:cart-drawer:close', this.closeDrawerViaEventHandler);
  }

  handleDrawerOpenViaEvent(evt) {
    this.open(evt.detail ? evt.detail.opener : null);
  }

  refreshCartContents() {
    fetch('/cart')
      .then(response => response.text())
      .then(html => {
        this.updateFromCartChange(html);
      })
      .catch(error => {
        console.error('Erreur lors de la mise à jour du panier:', error);
      });
  }

  updateFromCartChange(html) {

    if ( document.querySelector(".cart-drawer__empty-content").classList.contains("cart-drawer__empty-content--hidden") === false ){
      this.querySelector('cart-form').refreshFromHtml(html);
    }
    
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;

    const newSubtotal = tempDiv.querySelector('.subtotal');
    const currentSubtotal = this.querySelector('.subtotal');

    if (newSubtotal && currentSubtotal) {
      currentSubtotal.innerHTML = newSubtotal.innerHTML;

      var newPrice = parseFloat(document.querySelector("html .cart-drawer__footer .opposing-items .theme-money").textContent.replace(/[^A-Z0-9]+/ig, ''));

      if (document.querySelector(".free-shipping-bar").hasAttribute("data-free-shipping-amount")) {
        var freeShippingAmount = parseFloat(document.querySelector(".free-shipping-bar").getAttribute('data-free-shipping-amount'));
        var freeShippingProgress = document.querySelector(".free-shipping-bar").getAttribute('data-free-shipping-progress');
        if (newPrice < freeShippingAmount){
          var pourcentage = (newPrice / freeShippingAmount);
          var styleFreeShipping = document.querySelector(".free-shipping-bar").getAttribute('style').replace(freeShippingProgress, pourcentage);
          document.querySelector(".free-shipping-bar").setAttribute("style", styleFreeShipping);
          document.querySelector(".free-shipping-bar").setAttribute("data-free-shipping-progress", pourcentage);
          document.querySelector(".free-shipping-bar__message strong:not(:last-child)").textContent = "€" + parseFloat((freeShippingAmount - newPrice) / 100).toFixed(2);
        }else{
          var colorFinished = document.querySelector(".free-shipping-bar").getAttribute('color-full');
          document.querySelector(".free-shipping-bar").setAttribute("style", "--free-shipping-progress: 1; --free-shipping-bar-color: "+ colorFinished +";");
          document.querySelector(".free-shipping-bar").setAttribute("data-free-shipping-progress", "1");
        }
      }
      
    }

    // Sélecteurs adaptés à la structure de votre page panier
    const newCartContent = tempDiv.querySelector('.cart-item-list');
    const currentCartContent = this.querySelector('.cart-item-list');

    if (newCartContent && currentCartContent) {
      currentCartContent.innerHTML = newCartContent.innerHTML;

      // Rechargez les images et réinitialisez les composants
      theme.manuallyLoadImages(this);
      this.querySelectorAll('cc-cart-cross-sell').forEach((el) => el.init());
    }
  }
}

window.customElements.define('cart-drawer', CartDrawer);